<template>
    <ul class="friend-tabs nav nav-pills"
        role="tablist">
        <li :class="{active: currentPath === '/friends'}">
            <a href="/friends"><i class="glyphicon glyphicon-star"></i> What's New</a>
        </li>
        &nbsp;

        <li :class="{active: currentList === 'deleted-me'}">
            <a href="/friends/deleted-me"><i class="glyphicon glyphicon-remove"></i> Who Deleted Me</a>
        </li>
        &nbsp;

        <li :class="{active: currentList === 'i-deleted'}">
            <a href="/friends/i-deleted"><i class="glyphicon glyphicon-star"></i> People I Deleted</a>
        </li>
        &nbsp;

<!--        <li :class="{active: currentList === 'deactivated'}">-->
<!--            <a href="/friends/deactivated"><i class="glyphicon glyphicon-pause"></i> Who Deactivated</a>-->
<!--        </li>-->
<!--        &nbsp;-->

        <li :class="{active: currentList === 'current'}">
            <a href="/friends/current"><i class="glyphicon glyphicon-play"></i> Current Friends</a>
        </li>
    </ul>
</template>

<script>
export default {
    computed: {
        currentPath() {
            return this.$route.path;
        },
        currentList() {
            return this.$route.params.list;
        },
    },
};
</script>
